<template>
  <div id="HomePage">
    <!-- 轮播图 -->
    <div id="swiper" class="container-fuild">
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in swiperList" :key="index">
            <img class="swiper-lazy" :data-src="item.img" alt="轮播图">
            <div class="swiper-lazy-preloader"></div>
            <!-- <div class="swiper-slide-title">
                <h1>{{item.title}}</h1>
                <p>{{item.content}}</p>
            </div> -->
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>

        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <!-- 大数据管理系统 -->
    <div id="bigData" class="container-fuild">
      <div class="row bigData-container">
        <div class="col-xs-12 col-sm-12 col-md-6 wow zoomIn">
          <img class="img-responsive" src="@/assets/img/xuexiaojianjie.jpg" alt="学校简介">
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6">
          <h2 class="bigData-title">
            学校简介
            <small>/ School Profile</small>
          </h2>
          <p class="info">孝感市城市理工技工学校有限公司（孝感市城市理工技工学校）是经湖北省人力资源和社会保障厅批准成立的一所全日制技工学校。学校位于孝感市孝南区孝汉大道 18 号，占地面积 200 余亩，校园建筑面积 100000m²。地理位置优越，交通便利，环境优美，教学设备先进，生活设施完善，是学生学习和生活的理想场所。</p>
          <p class="info">学校深入贯彻大力发展技工教育重要指示精神，紧抓职业教育前途广阔、大有可为历史机遇，承担为产业转型升级和创新发展提供技能人才的重大历史使命。坚持党的领导，坚持正确办学方向，坚持立德树人，培育和弘扬“劳动光荣、技能宝贵、创造伟大”的时代风尚，深耕“以学生发展为本、教师成长为源、学校品质为先”的办学理念，实施“质量立校、人才强校、特色兴校”发展战略，深化产教融合、校企合作，践行工学一体化人才培养模式，实施准军事化管理，构建“三全”育人思想政治工作格局，强化学生专业技能培养，致力于培养德、智、体、美、劳全面发展的新时代实用型、创新型技能人才。</p>
          <!-- <h2 class="bigData-device">PC/PAD/Phone &nbsp; 全设备支持</h2> -->
          <a href="#" class="btn btn-lg btn-block btn-info">联系我们:0712-2036116</a>
        </div>
      </div>
    </div>
    <!-- 您身边的IT专家 -->
    <div id="contactUs" class="container-fuild text-center">
      <div class="container contactUs-container wow slideInUp">
        <h1>孝感市城市理工技工学院</h1>
        <h3>欢迎您</h3>
        <button
          class="btn btn-default btn-sm"
          onmouseleave="this.style.borderColor='#ffffff'; this.style.backgroundColor='#ffffff'; this.style.color='#3f3f3f';"
          onmouseenter="this.style.backgroundColor='transparent'; this.style.borderColor='#ffffff'; this.style.color='#ffffff';" @click="sign"
        >立刻报名</button>
        <div class="contactUs-contactWay">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
    <!-- 客户评价 -->
    <div id="customer" class="container-fuild">
      <div class="container customer-container">
        <p class="customer-title text-center">合作院校</p>
        <div class="swiper-container customer-swiper hidden-xs">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide customer-block"
              v-for="(item,index) in customerList"
              :key="index"
            >
              <div class="customer-logo">
                <img class="center-block" :src="item.logo" alt="logo">
              </div>
              <div class="customer-yh">
                <img src="@/assets/img/yinhao.png" alt="引号">
              </div>
              <div class="customer-content1">
                <small>{{item.content}}</small>
              </div>
              <div class="customer-content2">{{item.title}}</div>
            </div>
          </div>
          <!-- 如果需要导航按钮 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
        <div class="row visible-xs customer-block">
          <div class="col-xs-12" v-for="(item,index) in customerList" :key="index">
            <div class="customer-logo">
              <img class="center-block" :src="item.logo" alt="logo">
            </div>
            <div class="customer-yh">
              <img src="@/assets/img/yinhao.png" alt="引号">
            </div>
            <div class="customer-content1">
              <small>{{item.content}}</small>
            </div>
            <div class="customer-content2">
              <small>{{item.title}}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 为什么选择我们 -->
    <div id="whyChooseUs" class="conatiner-fuild">
      <div class="container">
        <div class="whyChooseUs-title text-center">
          <p>六大支持体系</p>
          <p>构建“全方位·一体化”人才培养模式</p>
        </div>
        <div class="row">
          <div
            class="col-xs-12 col-sm-6 col-md-3 server-wrapper"
            v-for="(item,index) in serverList"
            :key="index"
          >
            <div
              class="server-block wow slideInUp"
              onmouseenter="this.style.color='#28f';this.style.borderColor='#28f'"
              onmouseleave="this.style.color='#666';this.style.borderColor='#ccc'"
              style="margin-bottom:20px"
            >
              <img class="center-block" :src="item.logo" alt="logo">
              <p class="text-center">{{item.title}}</p>
              <div
                class="text-center"
                style="height:160px"
                v-html="item.content"
                onmouseenter="this.style.color='#28f'"
                onmouseleave="this.style.color='#ccc'"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { WOW } from 'wowjs';
export default {
  name: "HomePage",
  data() {
    return {
      swiperList: [
        {
          img: require("@/assets/img/banner11.jpg"),
          path: "",
          title: '您身边的IT专家1',
          content: '宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介',
        },
        {
          img: require("@/assets/img/banner22.jpg"),
          path: "",
          title: '您身边的IT专家2',
          content: '宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介',
        },
        {
          img: require("@/assets/img/banner33.jpg"),
          path: "",
          title: '您身边的IT专家3',
          content: '宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介',
        },
        {
          img: require("@/assets/img/banner44.jpg"),
          path: "",
          title: '您身边的IT专家4',
          content: '宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介',
        },
        {
          img: require("@/assets/img/banner55.jpg"),
          path: "",
          title: '您身边的IT专家4',
          content: '宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介',
        }
      ],
      customerList: [
        {
          logo: require("@/assets/img/school1.png"),
          title:
            "成都艺术职业大学（Chengdu Vocational University of Art），简称“成艺”",
          content:
            "位于四川省成都市，是经中华人民共和国教育部批准成立的一所全日民办普通本科职业大学。设有12个二级学院及多个教学机构，开设19个本科专业和近50个专科专业及专业方向；教职工1100余人。"
        },
        {
          logo: require("@/assets/img/school2.png"),
          title:
            "川北幼儿师范高等专科学校",
          content:
            "学校是经四川省人民政府批准成立的公办全日制普通高等专科学校。学校的前身为发端于1902年、创办于1937年的四川省广元师范学校；2012年，经省人民政府批准成立川北幼儿师范高等专科学校，学校占地面积503亩。"
        },
        {
          logo: require("@/assets/img/school3.png"),
          title:
            "西南石油大学（Southwest Petroleum University），简称“西南石大”（SWPU）",
          content:
            "主校区坐落于四川省成都市，由教育部、四川省与中国石油天然气集团有限公司、中国石油化工集团有限公司、中国海洋石油集团有限公司共建；是国家“双一流”建设高校，入选中西部高校基础能力建设工程、国家“111计划”、国家“特色重点学科项目”、国家建设高水平大学公派研究生项目、国家创新人才培养示范基地、全国高校实践育人创新创业基地、中国政府奖学金来华留学生接收院校、全国首批深化创新创业教育改革示范高校"
        },
        {
          logo: require("@/assets/img/school4.png"),
          title:
            "四川师范大学",
          content:
            "位于四川省会成都，国家首批“中西部高校基础能力建设工程”重点建设高校，四川省“双一流”建设计划高校，是四川省举办本科师范教育最早、师范类院校中办学历史最为悠久的省属重点大学；入选国家卓越教师培养计划、卓越工程师教育培养计划、国家级新工科研究与实践项目、国创计划、四川2011计划，是师范生公费教育政策实施院校、全国深化创新创业教育改革示范高校、教育部人文社会科学重点研究基地、国家级一流本科专业建设点、中俄“长江—伏尔加河”高校联盟、成渝地区双城经济圈高校联盟成员，拥有推荐免试研究生资格。"
        },
        {
          logo: require("@/assets/img/school5.png"),
          title:
            "天府新区通用航空职业学院",
          content:
            "是经四川省民政厅批准的一所民办非企业单位、非营利性全日制普通高等学校。学校由天府航空教育管理有限责任公司举办，得到解放军空军、四川省人民政府、中国民航西南地区管理局等大力支持，是中国第一所通用航空高校。"
        },
      
  
    
      ],
      serverList: [
        {
          logo: require("@/assets/img/tel.png"),
          title: "专业体系",
          content: "<p>学校专业设置紧密对接市场需求，紧跟产业发展步伐，不断增强人才培养对岗位要求的适应性。瞄准信息技术变革和数字经济产业优化升级的方向，构建特色专业集群，准确定位人才培养规格</p>"
        },
        {
          logo: require("@/assets/img/computer.png"),
          title: "教学体系",
          content: "<p>学校秉承“科技为本、创新育人”教育理念，深化“工学一体、研训结合”育人模式。通过校企双主体育人方式，将课程内容与职业标准对接、教学过程与生产过程对接，企业深度参与人才培养全过程，提升学生实践能力</p>"
        },
        {
          logo: require("@/assets/img/qq.png"),
          title: "管理体系",
          content: "<p>学校坚持立德树人、德技并修，倡导理论与实践并重、技术与人文融通、育人与育才统一。通过“五大特色”教育、“三位一体”管理、“八大名片”指引、操行自主应用等方式，关注学生全面成长成才，致力于培养高素质技术技能人才、能工巧匠、大国工匠</p>"
        },
        {
          logo: require("@/assets/img/skill.png"),
          title: "就业体系",
          content: "<p>学校坚持面向市场、服务发展、促进就业的办学方向，深化校企合作模式，校企供需匹配，学生在岗成才，通过获取多类职业技能等级证书，让更多学生就业有本领、发展有通道</p>"
        },
        {
          logo: require("@/assets/img/skill.png"),
          title: "升学体系",
          content: "<p>学生可以通过参加普通高考、对口升学、高职单招和艺考升学等途径进行全日制普通专科或本科学历教育，取得大专、本科毕业证书，深造渠道灵活多样、特长发挥优势明显</p>"
        },
        {
          logo: require("@/assets/img/skill.png"),
          title: "环境体系",
          content: "<p>学校顺应数字化时代的发展需要，大力推进现代信息技术应用，建设智慧校园，在信息化基础设施建设、数字教育资源开发、人员技术培训和管理系统应用等方面取得重要进展，数字生态建设取得积极成效</p>"
        },
      ]
    };
  },
  methods:{
    sign(){
      this.$router.push('/sign');
    }
  },
  mounted() {
    /* banner-swiper */
    new Swiper(".banner-swiper", {
      loop: true, // 循环模式选项
      effect: 'fade',
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      // 延迟加载
      lazy: {
        loadPrevNext: true
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
    /* customer-swiper */
    new Swiper(".customer-swiper", {
      loop: true, // 循环模式选项
      slidesPerView: 3,
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    })
    wow.init();
  }
};
</script>
<style scoped>
/* 整体盒子 */
#HomePage {
  width: 100%;
}

/* 轮播图 */
#swiper {
  height: 600px;
}
#swiper .banner-swiper {
  width: 100%;
  height: 100%;
}
#swiper .banner-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
}
#swiper .banner-swiper .swiper-slide{
  position: relative;
}
#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(51, 51, 51, 0.534);
  text-align: center;
  line-height: 80px;
}
#swiper .banner-swiper .swiper-slide-title > h1{
  font-size: 50px;
  margin-top: 12%;
}
#swiper .banner-swiper .swiper-slide-title > p{
  font-size: 20px;
  margin-top: 1%;
  font-weight: 700;
}
/* 大数据管理系统 */
#bigData {
  padding: 100px;
  transition: all ease 0.6s;
  box-sizing: border-box;
}
#bigData .bigData-title {
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
#bigData p {
  font-size: 14px;
  color: #333;
  line-height: 2rem;
}
#bigData .bigData-device {
  margin: 50px 0 20px;
}

/* 您身边的IT专家 */
#contactUs {
  color: #fff;
  height: 400px;
  background: url("../assets/img/contact_us_bg.jpg") 0 0 no-repeat;
  background-size: 100% 100%;
  transition: all ease 0.6s;
}
#contactUs .contactUs-container {
  padding-top: 50px;
}
#contactUs .contactUs-container button {
  width: 300px;
  height: 50px;
  margin-top: 40px;
}
#contactUs .contactUs-container .contactUs-contactWay span {
  display: inline-block;
  width: 48px;
  height: 48px;
  margin: 30px;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(1) {
  background: url("../assets/img/weixin.png") 0 0 no-repeat;
  background-size: 100% 100%;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(2) {
  background: url("../assets/img/weibo.png") 0 0 no-repeat;
  background-size: 100% 100%;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(3) {
  background: url("../assets/img/twitter.png") 0 0 no-repeat;
  background-size: 100% 100%;
}

/* 客户评价 */
#customer {
  padding: 50px 0;
  box-sizing: border-box;
  background: #efefef;
  transition: all ease 0.6s;
}
#customer .customer-title {
  font-size: 30px;
  color: rgb(102, 102, 102);
  margin: 0 0 30px;
}
#customer .customer-block {
  background: #fff;
  padding: 30px;
}
#customer .customer-logo img {
  width: 94px;
  height: 94px;
  border: 1px solid #ccc;
}
#customer .customer-yh img {
  width: 34px;
  height: 34px;
}
#customer .customer-content1 {
  height: 200px;
  padding-bottom: 20px;
  border-bottom: 1px solid #0ce9f1;
}
.info{
  text-indent: 2em;
}
#customer .customer-content2 {
  height: 60px;
  padding-top: 20px;
}
/* 为什么选择我们 */
#whyChooseUs {
  padding: 100px;
}
#whyChooseUs .whyChooseUs-title {
  margin-bottom: 50px;
}
#whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
  font-size: 25px;
  font-weight: 500;
}
#whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
  font-size: 14px;
}
#whyChooseUs .server-block {
  padding: 50px 20px;
  border: 1px solid #ccc;
  border-bottom: 5px solid #ccc;
}
#whyChooseUs .server-block img {
  width: 48px;
  height: 48px;
}
#whyChooseUs .server-block > p {
  font-size: 20px;
  margin: 30px 0;
}
#whyChooseUs .server-block > div {
  color: #ccc;
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  #swiper {
    height: 200px;
  }
  #bigData {
    padding: 30px;
  }
  #bigData .bigData-title {
    font-size: 20px;
  }
  #bigData .bigData-device {
    font-size: 20px;
    margin: 10px 0 10px;
  }
  #contactUs {
    height: 200px;
    transition: all ease 0.6s;
  }
  #contactUs .contactUs-container {
    padding-top: 0;
  }
  #contactUs .contactUs-container h1 {
    font-size: 25px;
  }
  #contactUs .contactUs-container h3 {
    font-size: 18px;
  }
  #contactUs .contactUs-container button {
    width: 200px;
    height: 30px;
    margin-top: 20px;
  }
  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin: 10px;
  }
  #customer {
    padding: 30px 0;
    box-sizing: border-box;
    background: #fff;
  }
  #customer .customer-title {
    font-size: 16px;
    font-weight: bold;
  }
  #customer .customer-logo img {
    width: 48px;
    height: 48px;
  }
  #customer .customer-block {
    padding: 30px;
  }
  #customer .customer-block > div {
    padding: 30px 0;
  }
  #whyChooseUs {
    padding: 20px 0;
    transition: all ease 0.6s;
  }
  #whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
    font-size: 20px;
    font-weight: 700;
  }
  #whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
    font-size: 12px;
  }
  #whyChooseUs .server-block {
    padding: 50px 0;
    border: 1px solid #ccc;
    border-bottom: 5px solid #ccc;
  }
  #whyChooseUs .server-block img {
    width: 48px;
    height: 48px;
  }
  #whyChooseUs .server-block > p {
    font-size: 20px;
    margin: 30px 0;
  }
  #whyChooseUs .server-block > div {
    color: #ccc;
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #swiper {
    height: 400px;
  }
  #bigData {
    padding: 60px;
  }
  #bigData .bigData-title {
    font-size: 30px;
  }
  #bigData .bigData-device {
    font-size: 30px;
    margin: 30px 0 15px;
  }
  #contactUs {
    height: 300px;
  }
  #contactUs .contactUs-container {
    padding-top: 50px;
  }
  #contactUs .contactUs-container h1 {
    font-size: 30px;
  }
  #contactUs .contactUs-container h3 {
    font-size: 20px;
  }
  #contactUs .contactUs-container button {
    width: 300px;
    height: 50px;
    margin-top: 30px;
  }
  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 32px;
    height: 32px;
    margin: 15px;
  }
  #customer .customer-title {
    font-size: 24px;
  }
  #whyChooseUs {
    padding: 20px 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/view/HomePage.vue